import * as Yup from 'yup';

const SuggestedAddressModalSchema = Yup.object().shape({
  keepSuggestedAddress: Yup.boolean(),
  keepAddressEntered: Yup.boolean(),
});

export default SuggestedAddressModalSchema;
